import { type ReactNode, type ToggleEventHandler } from 'react';

import { type TrackClickedData } from '#/snippets/track-clicked.attributes';

import { DropdownRichDetails, DropdownSummary } from './Dropdown.styled';

type Props = {
  /**
   * Dropdown uses `<summary>` + `<details>` so the trigger should not be a `<button>`
   * or other element that hijacks the `onClick` event
   */
  trigger: ReactNode;
  children: ReactNode;
  qaId?: string;
  desktopTriggersOnHover?: boolean;
  summaryAriaLabel?: string;
  trackClickedOpen?: TrackClickedData;
  onToggle?: ToggleEventHandler<HTMLDetailsElement>;
};

export function Dropdown({
  trigger,
  children,
  qaId,
  desktopTriggersOnHover,
  summaryAriaLabel,
  trackClickedOpen,
  onToggle,
}: Props) {
  return (
    <DropdownRichDetails
      singleton
      desktopTriggersOnHover={Boolean(desktopTriggersOnHover)}
      trackClickedOpen={trackClickedOpen}
      onToggle={onToggle}
      qaId={qaId}
    >
      <DropdownSummary aria-label={summaryAriaLabel}>{trigger}</DropdownSummary>

      {children}
    </DropdownRichDetails>
  );
}
